var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94922 8.59999C8.94922 4.98577 11.885 2.04999 15.4992 2.04999C19.0963 2.04999 22.0492 4.86884 22.0492 8.49999C22.0492 12.1142 19.1134 15.05 15.4992 15.05C14.9689 15.05 14.4451 14.974 13.9484 14.8462C13.9241 15.5151 13.3741 16.05 12.6992 16.05H10.9492V17.8C10.9492 18.4903 10.3896 19.05 9.69922 19.05H7.94922V20.3C7.94922 21.2665 7.16572 22.05 6.19922 22.05H3.69922C2.73272 22.05 1.94922 21.2665 1.94922 20.3V18.1284C1.94922 17.3991 2.23895 16.6996 2.75467 16.1839L8.99046 9.94809C9.04493 9.89362 9.07749 9.80547 9.05969 9.704C8.99939 9.36035 8.94922 8.9872 8.94922 8.59999ZM18.2493 7C18.2493 6.30964 17.6896 5.75 16.9993 5.75C16.3089 5.75 15.7493 6.30964 15.7493 7C15.7493 7.69036 16.3089 8.25 16.9993 8.25C17.6896 8.25 18.2493 7.69036 18.2493 7Z",
    fill: "#5566AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.d830ae2e.svg";
export { ForwardRef as ReactComponent };